import React from 'react';

import { Box } from '@twilio-paste/core/box';
import { Stack } from '@twilio-paste/core/stack';
import { Text } from '@twilio-paste/core/text';

import { CopyButton } from '../common/CopyButton';

interface SearchCustomerResultProps {
  responseBody: string;
  isFetched: boolean;
  data: any;
  httpStatus: number | null;
}

export function SearchCustomerResult({ responseBody, isFetched, data, httpStatus }: SearchCustomerResultProps) {
  return (
    <>
      <Box backgroundColor="colorBackground" padding="space40" borderRadius="borderRadius20" minHeight="400px" textAlign="right">
        <Box textAlign="left">
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all', margin: 0, height: '100%' }}>{responseBody}</pre>
        </Box>
        {isFetched && data && (
          <CopyButton title="Copy JSON" value={responseBody} text-align="right" />
        )}
      </Box>
      {httpStatus && (
        <Stack orientation="horizontal" spacing="space30">
          <Text as="div" fontWeight="fontWeightBold" marginBottom="space20">Status: {httpStatus}</Text>
        </Stack>
      )}
    </>
  );
}
